import { AppState } from '../models/state/appState';
import { DropdownItemsState } from '../models/state/simProvision/simProvisionState';

/**
 * Selects the tariff standard bolt-ons
 * @param state The application state.
 */
export function selectPortNetworks(state: AppState): DropdownItemsState {
  return state.portNetworks;
}
